import React, { useState, useRef } from "react";
// import bgImg from "../assets/images/HEROPAGE.png";
import emailjs from "@emailjs/browser";
import "./ContactForm.css"; // Import the CSS file
import contacImg from "../assets/images/contact-img.png";
import Lottie from "lottie-react";
import successAnimation from "../assets/Rocket.json";

const ContactForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAnimation, setShowAnimation] = useState(true);

  const [shouldLoop, setShouldLoop] = useState(false);

  const animationRef = useRef();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (animationRef.current) {
        animationRef.current.setLoop(true);
        animationRef.current.play();
      }
      setShouldLoop(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  const formRef = useRef(); // Create a ref for the form

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs
      .send(
        "service_5jfcbqu",
        "template_x8ov0ul",
        formData,
        "1twDpMDkAb0o2KizL"
      )
      .then((response) => {
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          service: "",
          message: "",
        });

        // // Stop animation and close after a small delay
        // if (animationRef.current) {
        //   animationRef.current.stop();
        // }

        setShowAnimation(false);

        // setTimeout(() => {
        //   onClose();
        // }, 5000); // Short delay before closing
      })

      .catch((err) => {
        // console.error("FAILEDinggg...", err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleClickOutside = (e) => {
    // Check if the click is outside the form
    if (formRef.current && !formRef.current.contains(e.target)) {
      onClose(); // Close the form
    }
  };

  React.useEffect(() => {
    // Add event listener to handle clicks outside the form
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Cleanup the event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    isOpen && (
      <div className="fixed contact-form-main-div inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]">
        {showAnimation ? (
          <div
            ref={formRef}
            className="bg-white  rounded-[40px] shadow-lg max-w-4xl w-full md:mt-5"
          >
            <div className="md:grid grid-cols-2 gap-4">
              <div
                className="hidden  bg-[#7366fc] pt-10 h-full md:flex flex-col justify-between  rounded-l-[40px]"
                // style={{
                //   background: `url(${bgImg})`,
                //   backgroundRepeat: "round",
                //   backgroundSize: "cover",
                // }}
              >
                <div
                  className=" px-8 h-full"
                  style={{
                    background: `url(${contacImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "bottom",
                    backgroundSize: "85%",
                  }}
                >
                  <h2 className="text-[30px] md:text-[30px] leading-[35px] font-bold text-[#C0FF00] size-fit">
                    Let's get to work.
                  </h2>
                  <p className="text-white mt-2 size-fit">
                    We'll contact you within a couple of hours to schedule a
                    meeting and discuss your goals.
                  </p>
                </div>
                {/* <img
                  src={contacImg}
                  alt="Contact Us"
                  className="object-cover mt-6 h-full w-auto"
                /> */}

                {/* className="h-[300px] w-[300px] mx-auto" */}
              </div>
              <div className=" pb-8 pt-10 px-10 sm:pl-2 sm:pr-8 flex flex-col justify-between">
                <h2 className="text-[30px] md:text-[30px] uppercase font-bold text-[#7366fc] size-fit">
                  Drop us a message
                </h2>
                <form
                  onSubmit={handleSubmit}
                  className="space-y-4  font-medium mt-4 md:mt-8"
                >
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name*"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    className="w-full border py-2 px-4   bg-white rounded-full"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address*"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full border py-2 px-4   bg-white rounded-full"
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number*"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full border py-2 px-4   bg-white rounded-full"
                  />
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                    className="w-full border py-2 px-4  bg-white rounded-full"
                  >
                    <option value="" disabled>
                      Select Service*
                    </option>
                    <option value="UI UX Design">UI UX Design</option>
                    <option value="3D Illustration">Animation</option>
                    <option value="Logo & Branding">Logo & Branding</option>
                    <option value="Others">Other</option>
                  </select>
                  <textarea
                    name="message"
                    placeholder="Your Message*"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="w-full border py-2 px-4   bg-white rounded-full"
                  />
                  <div className="flex justify-between w-full">
                    <button
                      type="button"
                      onClick={onClose}
                      className="mt-2 text-red-500"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="font-medium btn-hover-eft transition-transform duration-300 ease-in-out uppercase bg-[#c0ff00] hover:scale-105 px-4 py-2 rounded-full flex gap-2 border border-black border-b-4 z-50"
                    >
                      {isSubmitting ? (
                        <div className="flex items-center gap-2">
                          <svg
                            className="animate-spin h-5 w-5 text-black"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                            ></path>
                          </svg>
                          Sending...
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-[#7366fc] rounded-[40px] shadow-lg py-8">
            <h2 className="text-[30px] md:text-[30px] leading-[35px] font-bold text-[#C0FF00] text-center">
              We'll get back in a while!
            </h2>
            <Lottie
              animationData={successAnimation}
              loop={false}
              autoplay={true}
              className="object-cover h-auto w-[400px]  mx-auto"
              onComplete={() => {
                setShowAnimation(true); // Reset for next time
                onClose(); // Close the form
              }}
            />
          </div>
        )}
      </div>
    )
  );
};

export default ContactForm;
